import React from 'react';

const LogoIcon = ({ ...props }) => (
  <img 
  src="/MSL-Favicon-2025.png"
    alt="MSL Logo" 
    style={{
      width: '100px',
      height: 'auto',
      objectFit: 'contain',
      marginLeft: '45%',
      ...props.style
    }}
  />
);

export default LogoIcon;